import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',

    '& > p': {
      color: theme.palette.grey['500'],
      fontSize: '.85rem',
      paddingRight: theme.spacing(0.85),
    },
  },
  iconsWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',

    '& li': {
      padding: 0,

      '& svg': {
        color: theme.palette.grey['400'],
        fontSize: '1rem',
        marginRight: theme.spacing(0.75),
      },
    },
  },
  tooltip: {
    whiteSpace: 'pre-line',
  },
}));
